import type { OfferSku } from "../domain/schema";

type PurchasableOffer = Extract<
  OfferSku,
  | "paper-kingdom-production"
  | "paper-kingdom-launch-growth"
  | "paper-kingdom-reseller"
>;

export const offerPurchaseLinks: Record<
  PurchasableOffer,
  { label: string; url: string }
> = {
  "paper-kingdom-production": {
    label: "Get book-making tools",
    url: "https://warriorplus.com/o2/buy/pj61xz/wmvn6g/hhwzd6",
  },
  "paper-kingdom-launch-growth": {
    label: "Get selling tools",
    url: "https://warriorplus.com/o2/buy/pj61xz/cvjfxw/pfn0m2",
  },
  "paper-kingdom-reseller": {
    label: "Get Reseller Rights",
    url: "https://warriorplus.com/o2/buy/pj61xz/nnk3yy/dwl1ty",
  },
};

export function getOfferPurchaseLink(offer: OfferSku) {
  if (offer in offerPurchaseLinks) {
    return offerPurchaseLinks[offer as PurchasableOffer];
  }
  return null;
}

export const paperKingdomAffiliateSignupUrl =
  "https://warriorplus.com/aff-offer/o/pj61xz";

export const paperKingdomPartnerResourcesUrl =
  "https://aiagentoffer.com/paperkingdom/jv";
